import './App.css';
import Shop from './components/Shop/Shop';
import Cart from './components/Cart/Cart';

function App() {
  return (
    <div>
      <Cart></Cart>
      <Shop></Shop>
    </div>
  );
}

export default App;
